<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {

    };
  },
  methods: {
    
  }
};
</script>

<style>
/* .w-e-text-container {
  height: 600px !important;
}
.addNotify .w-e-text-container {
  height: 400px !important;
} */
#content.main {
  width: 100%;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  position: relative;
}

.el-button--mini,
.el-button--small {
  font-size: 13px;
}
/* .el-button--mini,
.el-button--small:hover {
  text-decoration: underline;
} */
.el-table__empty-block {
  min-height: 500px !important;
}

body,
html {
  width: 100%;
  height: 100%;
}
#app > div {
  /* min-width: 1250px; */
}
#app > div.share {
  min-width: auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue